document.querySelectorAll('.bs-mag').forEach(function(sec){
  var track = sec.querySelector('[data-bs-mag-track]');
  if(!track) return;
  sec.querySelectorAll('.bs-mag__arrow').forEach(function(btn){
    btn.addEventListener('click', function(){
      var dir = btn.getAttribute('data-dir') === 'next' ? 1 : -1;
      var card = track.querySelector('.bs-mag__card--row');
      var step = card ? (card.getBoundingClientRect().width + 12) : track.clientWidth;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    });
  });
});
